<template>
  <div class="panel">
    <div class="panel-heading">
      <h4 class="panel-title">群组简介</h4>
      <div class="button-container" v-if="right__group_home_content && hasEditGroupInfoPermission">
        <a @click="toggleEdit">
          <i class="iconfont icon-send"></i>
          修改
        </a>
      </div>
    </div>
    <div class="panel-body">
      <div class="form-horizontal">
        <div class="form-group" v-show="showDesc">
          <div class="col-md-12">
            <div class="group-info" v-html="groupContent"></div>
          </div>
        </div>
        <div class="form-group" v-show="!showDesc">
          <div class="col-md-12">
            <div ref="editor" class="editor"></div>
          </div>
        </div>
        <div class="form-group" v-show="!showDesc">
          <div class="col-md-12">
            <button
              class="btn btn-primary"
              type="button"
              @click="saveGroupContent"
              v-if="hasEditGroupInfoPermission"
            >
              保存
            </button>
            <button class="btn btn-default" type="button" @click="toggleEdit">
              取消
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let editor = null;
import E from "wangeditor";
import { getGroupContent, saveGroupContent } from "@/api/group/group";
export default {
  name: "GroupHome",
  data() {
    return {
      groupContent: "",
    };
  },
  created() {
    this.groupNumber = this.$route.params.groupNumber;
  },
  computed: {
    right__group_home_content () {
      return this.$store.getters.right__group_home_content
    },
    hasEditGroupInfoPermission() {
      return (
        this.permissions.public_operations == "ALL" ||
        this.permissions.public_operations.indexOf("editGroupInfo") > -1
      );
    },
    permissions() {
      return this.$store.state.group.permissions;
    },
    groupInfo() {
      return this.$store.state.group.groupInfo;
    },
    showDesc() {
      return this.$store.state.group.showDesc;
    },
  },
  methods: {
    // 获取群简介
    getGroupContent() {
      getGroupContent(this.groupNumber)
        .then((res) => {
          if (res.status_code === 200) {
            this.groupContent = res.entity.group_home_content;
            editor.txt.html(this.groupContent);
            // this.$store.commit("SET_GROUP_SHOWDESC", true);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 保存群简介
    saveGroupContent() {
      saveGroupContent({
        group_number: this.groupNumber,
        group_home_content: this.groupContent,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$message({
              type: "success",
              message: res.message,
            });
            this.toggleEdit();
            this.getGroupContent();
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 修改编辑状态
    toggleEdit() {
      this.$store.commit("SET_GROUP_SHOWDESC", !this.showDesc);
    },
  },
  mounted() {
    editor = new E(this.$refs.editor);
    editor.customConfig.onchange = (html) => {
      this.groupContent = html;
    };
    editor.create();
    this.getGroupContent();
  },
};
</script>

<style>
.editor .w-e-menu,
.editor .w-e-text-container {
  z-index: 999 !important;
}
</style>